<template>
  <div id="card">
    <div class="card-left">
      <img
        :src="
          info.imgUrl
            ? info.imgUrl
            : require('../../../assets/images/home/land.png')
        "
        alt=""
      />
    </div>
    <div class="card-right">
      <div class="card-right-li1">
        <div class="card-right-li1-l font-1">{{ info.name }}</div>
        <div class="card-right-li1-r font-2">
          <div class="card-right-li1-r-l">审批类型：</div>
          <div class="card-right-li1-r-r">{{ info.approvalType }}</div>
        </div>
      </div>
      <div class="card-right-li1 font-3 mgn-top-20">
        <div class="card-right-li1-l">
          <div class="card-right-li-r-title">联系人：</div>
          <div class="card-right-li-r-content">{{ info.person }}</div>
        </div>
        <div class="card-right-li1-r">
          <div class="card-right-li-r-title">园区级别：</div>
          <div class="card-right-li-r-content">{{ info.parkLevelName }}</div>
        </div>
      </div>
      <div class="card-right-li1 font-3 mgn-top-10">
        <div class="card-right-li1-l">
          <div class="card-right-li-r-title">联系方式：</div>
          <div class="card-right-li-r-content">{{ info.phone }}</div>
        </div>
        <div class="card-right-li1-r">
          <div class="card-right-li-r-title">园区面积：</div>
          <div class="card-right-li-r-content">
            {{ info.actualAreaActual }}公顷
          </div>
        </div>
      </div>
      <div class="card-right-li1 font-3 mgn-top-10">
        <div class="card-right-li1-d-l">园区位置:</div>
        <div class="card-right-li1-d-r">{{ info.locationActual }}</div>
      </div>
      <div class="card-right-li1 font-3 mgn-top-10">
        <div class="card-right-li1-d-l">产业类型：</div>
        <div class="card-right-li1-d-r">
          {{ info.leadingIndustry }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
#card {
  width: 100%;
  display: flex;
  height: 200px;
}
.card-left {
  width: 318px;
  height: 100%;
}
.font-1 {
  font-size: 1rem;
  font-weight: 600;
}
.font-2 {
  font-size: 0.95rem;
  color: red;
  font-weight: 600;
}
.font-3 {
  font-size: 0.85rem;
}
.mgn-top-20 {
  margin-top: 20px;
}
.mgn-top-10 {
  margin-top: 10px;
}
.card-left > img {
  width: 100%;
  height: 100%;
}
.card-right {
  width: calc(100% - 318px);
  padding: 10px 25px;
}
.card-right-li1 {
  display: flex;
  width: 100%;
}
.card-right-li1-l {
  width: 100%;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-right-li1-r {
  display: flex;
  width: 40%;
}
.card-right-li-r-title {
  width: 75px;
  color: #000;
}
.card-right-li-r-content {
  width: calc(100% - 75px);
  color: #626262;
}
.card-right-li1-d-l {
  width: 75px;
}
.card-right-li1-d-r {
  width: calc(100% - 75px);
  line-height: 22px;
  color: #626262;
}
</style>